import { render, staticRenderFns } from "./amazonChannelBar.vue?vue&type=template&id=57c3a92a&scoped=true"
import script from "./amazonChannelBar.vue?vue&type=script&lang=js"
export * from "./amazonChannelBar.vue?vue&type=script&lang=js"
import style0 from "./amazonChannelBar.vue?vue&type=style&index=0&id=57c3a92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c3a92a",
  null
  
)

export default component.exports